import { app } from '../../../../bootstrap/core';
import { historyEntryTitleComponent } from './historyEntryTitle.component';

app.component('historyEntryTitle', historyEntryTitleComponent);
